import type { Opts } from 'linkifyjs';
import type { ReactNode } from 'react';

import Linkify from 'linkify-react';
import { useTranslation } from 'react-i18next';

type Props = {
  options?: Opts;
  children: ReactNode;
};

export function LinkifiedMessage({ options, children }: Props) {
  const { t } = useTranslation();

  const _options: Opts = {
    attributes: { title: t('common.chat.externalLinkTitle') },
    rel: 'noopener',
    target: '_blank',
    ...options,
  };

  return <Linkify options={_options}>{children}</Linkify>;
}
